import * as votes from '../icmib/votes';
import * as ideas from '../icmib/ideas';

ICMIB.ideas = ideas;
ICMIB.votes = votes;
